"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _RemoveAllDialog = _interopRequireDefault(require("./RemoveAllDialog"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TooltipContent = function TooltipContent() {
  return /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "remove_all_tooltip"
  }, ' ', "Remove", ' ', /*#__PURE__*/_react.default.createElement("b", null, "All"), ' ', "items in cart.", ' ');
};
var DeleteCellView = function DeleteCellView(_ref) {
  var column = _ref.column,
    count = _ref.count;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    displayDialog = _ref3[0],
    setDisplay = _ref3[1];
  var toggleDialogDisplay = function toggleDialogDisplay() {
    return setDisplay(!displayDialog);
  };
  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    scope: "col",
    className: "del_all_row"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "del_all_row_text"
  }, "Remove"), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    id: "del_all_row_tooltip",
    className: "del_all_row_tooltip",
    title: TooltipContent(),
    renderComponent: TooltipContent()
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "help",
    className: "del_all_row_btn"
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowDropDown, {
    className: "del_all_row_btn_icon",
    onClick: toggleDialogDisplay
  }))), /*#__PURE__*/_react.default.createElement(_RemoveAllDialog.default, {
    open: displayDialog,
    removeAllFiles: column.headerEventHandler,
    count: count,
    toggleDisplay: toggleDialogDisplay
  }));
};
var _default = DeleteCellView;
exports.default = _default;